// extracted by mini-css-extract-plugin
module.exports = {"root":"Media_root_2RN_v","close":"Media_close_2CyUQ","fullscreen":"Media_fullscreen_1J1c5"};